import FormLogin from '@/vistas/Auth/FormLogin'
import FormRecuperar from '@/vistas/Auth/FormRecuperar'
import FormRegistrar from '@/vistas/Auth/FormRegistrar'
import Vue from 'vue'
import Router from 'vue-router'
import firebase from '../firebase'
import { initProgress } from '../progressbar'

const  lazyLoad = (view) => () => import(`@/vistas/${view}.vue`)

//  Widgets Components
import mainView from '../mainView'

//import blankPage from '../views/samples/general-pages/blank-page'

Vue.use(Router)

const router = new Router({
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  mode: 'hash',
  routes: [
    {
      path: '/cargando',
      component: lazyLoad("Auth/FormCargando"),
      name: 'cargando'
    },
    {
      path: '/',
      component: FormLogin,
      name: 'login'
    },
    {
      path: '/login',
      component: FormLogin,
    },
    {
      path: '/suscripcion',
      component: lazyLoad("Suscripciones/Suscripcion"),
      name: 'suscripcion',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/validando',
      component: lazyLoad("Suscripciones/Validando"),
      name: 'validando_pago',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/restringido',
      component: lazyLoad("Suscripciones/Restringido"),
      name: 'restringido',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/sucursal_restringido',
      component: lazyLoad("Suscripciones/RestringidoSucursal"),
      name: 'sucursal_restringido',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/registrarse',
      component: FormRegistrar,
    },
    {
      path: '/recuperar',
      component: FormRecuperar,
    },
    {
      path: '/franquicia-cambio',
      name: 'franquicia-cambio',
      component: lazyLoad("Corporativo/Franquicia_cambio"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/inicio',
      redirect: 'home',
      component: mainView,
      children: [
        {
          path: '/paciente',
          name: 'paciente_nuevo',
          component: lazyLoad("Pacientes/Paciente"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/propietario/:espaciente/:id',
          name: 'paciente_nuevo_con_propietario',
          component: lazyLoad("Pacientes/Paciente"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/almacenes/',
          name: 'almacenes',
          component: lazyLoad("Almacenes/index"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/paciente/:id',
          name: 'paciente_editar',
          component: lazyLoad("Pacientes/Paciente"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/pacientes',
          name: 'pacientes',
          component: lazyLoad("Pacientes/Pacientes"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/pacientes/:id_paciente/plan_bienestar',
          name: 'plan_bienestar_paciente',
          props:true,
          component: lazyLoad("Pacientes/Plan_Bienestar"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/Productos',
          name: 'Productos',
          component: lazyLoad("Productos/Productos"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/proveedores',
          name: 'proveedores',
          component: lazyLoad("Proveedores/index"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/proveedor/:id_proveedor?',
          name: 'proveedor',
          props:true,
          component: lazyLoad("Proveedor/index"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/compras',
          name: 'compras',
          component: lazyLoad("Compras/index"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/gastos',
          name: 'gastos',
          component: lazyLoad("Gastos/index"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/inventarios',
          name: 'inventarios',
          component: lazyLoad("Inventarios/index"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/venta_mostrador',
          name: 'ventas',
          component: lazyLoad("Venta_Mostrador/index"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/venta_mostrador/detalle',
          name: 'ventasDetalle',
          component: lazyLoad("Venta_Mostrador/Detalle"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/compra/:id_compra?',
          name: 'compra',
          props:true,
          component: lazyLoad("Compra/index"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/Servicios',
          name: 'Servicios',
          component: lazyLoad("Servicios/Servicios"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/Unidades',
          name: 'unidades',
          component: lazyLoad("Unidades/index"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/Colores',
          name: 'Colores',
          component: lazyLoad("Colores/Colores"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/categorias',
          name: 'categorias',
          component: lazyLoad("Catalogos/Categorias/index"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/categorias/:idCategoria/conceptos',
          name: 'conceptos',
          component: lazyLoad("Catalogos/Categorias/Conceptos/index"),
          props:true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/Espacios',
          name: 'Espacios',
          component: lazyLoad("Espacios/Espacios"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/panel',
          name: 'panel',
          component: lazyLoad("Panel/Panel"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/pacientes/:id_paciente/casos/',
          name: 'Casos',
          component: lazyLoad("Casos/Casos"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/pacientes/:id_paciente/casos/',
          name: 'Casos_nuevo',
          component: lazyLoad("Casos/Casos"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/Casos/',
          name: 'CasosGeneral',
          component: lazyLoad("Casos/CasosGeneral"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/pacientes/:id_sucursal/ServiciosCasos/:id_caso',
          name: 'ServiciosCasos',
          component: lazyLoad("Casos/ServiciosCasos"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/pacientes/:id_sucursal/ServiciosCasosLabs/:id_caso',
          name: 'ServiciosCasosLabs',
          component: lazyLoad("Casos/ServiciosCasosLabs"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/Especies',
          name: 'Especies',
          component: lazyLoad("Especies/Especies"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/estudios',
          name: 'Estudios',
          component: lazyLoad("Estudios/Estudios"),
          meta: {
            requiresAuth: true
          }
        },
        // Pantallas Propietarios #Angel
        {
          path: '/propietarios',
          name: 'propietarios',
          component: lazyLoad("Propietarios/Propietarios"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/propietario/:id',
          name: 'propietario',
          component: lazyLoad("Propietarios/Propietario"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/propietario',
          name: 'propietarioNuevo',
          component: lazyLoad("Propietarios/Propietario"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        // Vista de empleados
        {
          path: '/empleados',
          name: 'empleados',
          component: lazyLoad("Empleados/Empleados"),
          meta: {
            requiresAuth: true
          }
        },
        // Vista de Home
        {
          path: '/home',
          name: 'home',
          component:lazyLoad("Home/Home"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/empleado/:id',
          name: 'empleado',
          component: lazyLoad("Empleados/Empleado"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/empleado',
          name: 'empleadoNuevo',
          component: lazyLoad("Empleados/Empleado"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/panel_roles',
          name: 'panel_roles',
          component: lazyLoad("Panel_roles/Panel_roles"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/panel_rol',
          name: 'panel_rolnuevo',
          component: lazyLoad("Panel_roles/Panel_rol"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/panel_rol/:id',
          name: 'panel_rol',
          component: lazyLoad("Panel_roles/Panel_rol"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/panel_sucursales/:id',
          name: 'panel_sucursales',
          component: lazyLoad("Panel/Sucursales"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/cliente',
          name: 'cliente',
          component: lazyLoad("Panel/Cliente"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        // Pantallas Corporativo #Angel
        {
          path: '/corporativo',
          name: 'Corporativo',
          component: lazyLoad("Corporativo/Corporativo"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/corporativo_info',
          name: 'Corporativo_info',
          component: lazyLoad("Corporativo/Corporativo_info"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/sucursales/:nombre/:id',
          name: 'Sucursales',
          component: lazyLoad("Corporativo/Sucursales"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/sucursal/:franquicia_param/:id',
          name: 'Sucursal',
          component: lazyLoad("Corporativo/Sucursal"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/sucursal/:franquicia_param',
          name: 'SucursalNuevo',
          component: lazyLoad("Corporativo/Sucursal"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },

        // Pantallas Usuarios #Fortis
        {
          name: 'usuarios',
          path: '/usuarios',
          component: lazyLoad("Usuarios/Usuarios"),
          meta: {
            requiresAuth: true
          }
        },
        {
          name: 'usuario',
          path: '/usuario/:id',
          component: lazyLoad("Usuarios/Usuario"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          name: 'perfil',
          path: '/perfil/:id',
          component: lazyLoad("Usuarios/Usuario"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          name: 'usuarioNuevo',
          path: '/usuario',
          component: lazyLoad("Usuarios/Usuario"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },

        // Pantallas Planes de Bienestar #Angel
        {
          name: 'planes_bienestar',
          path: '/planes_bienestar',
          component: lazyLoad("Planes_Bienestar/Planes_Bienestar"),
          meta: {
            requiresAuth: true
          }
        },
        {
          name: 'plan_bienestar',
          path: '/plan_bienestar',
          component: lazyLoad("Planes_Bienestar/Plan_Bienestar"),
          meta: {
            requiresAuth: true
          }
        },
        {
          name: 'plan_bienestar_editar',
          path: '/plan_bienestar/:id',
          component: lazyLoad("Planes_Bienestar/Plan_Bienestar"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          name: 'agenda',
          path: '/agenda',
          component: lazyLoad("Agenda/Agenda"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          name: 'board',
          path: '/board',
          component: lazyLoad("Agenda/Board"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/corte/:id',
          name: 'corte_editar',
          component: lazyLoad("Cajas/Corte"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/cortes_caja',
          name: 'cortes_caja',
          component: lazyLoad("Cajas/Cortes_Caja"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/Cajas',
          name: 'Cajas',
          component:lazyLoad("Cajas/Cajas"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/propietarios/:id_propietario/saldo',
          name: 'saldo',
          component: lazyLoad("Saldo/Saldo"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/graficas',
          name: 'graficas',
          component: lazyLoad("Graficas/Graficas"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/descuentos',
          name: 'descuentos',
          component: lazyLoad("Descuentos/Descuentos"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/reportes',
          name: 'reportes',
          component: lazyLoad("Reportes/Reportes"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/reportes2',
          name: 'reportes2',
          component: lazyLoad("Reportes2/index"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/reportes3',
          name: 'reportes3',
          component: lazyLoad("Reportes3/index"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/roles',
          name: 'roles',
          component: lazyLoad("Roles/Roles"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/rol',
          name: 'rol_nuevo',
          component: lazyLoad("Roles/Rol"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/rol/:id',
          name: 'rol_editar',
          component: lazyLoad("Roles/Rol"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/notificaciones/:id',
          name: 'notificaciones',
          component: lazyLoad("Notificaciones/Notificaciones"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: '/pago_completado/',
          name: 'pago_completado',
          component: lazyLoad("Pagos/Completado"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/pago_cancelado/',
          name: 'pago_cancelado',
          component: lazyLoad("Pagos/Incompleto"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: '/sucursal_cancelado/',
          name: 'sucursal_cancelado',
          component: lazyLoad("Pagos/Sucursal_cancelado"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/sucursal_completado/',
          name: 'sucursal_completado',
          component: lazyLoad("Pagos/Sucursal_completado"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/formatos/',
          name: 'formatos',
          component: lazyLoad("Formatos/Formatos"),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/vencimientos',
          name: 'vencimientos',
          component: lazyLoad("Vencimientos/Vencimientos"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/importador',
          name: 'Importador',
          component: lazyLoad("Importador/index"),
          meta: {
            requiresAuth: true
          }
        },
        /*{
          path: '/blank_page',
          name: 'blank_page',
          component: blankPage,
          meta: {
            requiresAuth: true
          }
        },*/
        
      ]
    },
    {
      path: '*',
      redirect: '/pages/error_404',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '/pages/error_404',
          component: () => import(`@/views/samples/error-pages/error_404`),
        },
        {
          path: '/pages/error_500',
          component: () => import(`@/views/samples/error-pages/error_404`),
        },
      ]
    }
  ]
})

initProgress(router);

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (!window.inicialPath) {
    window.inicialPath = to.fullPath
  }

  //if (requiresAuth && !currentUser) next('/')
  if (requiresAuth && !currentUser) {
    next('/cargando')
  } else if (!requiresAuth && currentUser) {
    next('/cargando')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js